import {isFeatureEnabled} from 'feature-flags';

import {not} from 'ramda';

import {featureFlags} from '@dms/feature-flags';
import {orchestrationNotificationTypes} from '@dms/shared';

/**
 * Whether a notification is an automation-rule one the orchestration flag hides. Read by the item
 * builder, which drops it, and by the unread count, so the badge never counts what the list hides.
 */
export const isHiddenRuleNotification = (type: string) =>
  orchestrationNotificationTypes.some((ruleType) => ruleType === type) &&
  not(isFeatureEnabled(featureFlags.ORCHESTRATION_MODULE));
